import type { User } from 'firebase/auth';
import { ref } from 'vue';

const userAuth = ref<User | null>(null);
/**
 * A Firebase session says nothing about the GYMing backend user. Until the
 * backend document exists, every `authUserMiddleware` endpoint answers 401,
 * and the shared 401 handler force-logs-out whatever flow is in progress.
 */
const isBackendUserProvisioned = ref(false);

function setUser(user: User | null) {
  userAuth.value = user;
  if (!user) isBackendUserProvisioned.value = false;
}

function clearUser() {
  userAuth.value = null;
  isBackendUserProvisioned.value = false;
}

function setBackendUserProvisioned(provisioned: boolean) {
  isBackendUserProvisioned.value = provisioned;
}

export function useAuthState() {
  return { userAuth, setUser, clearUser, isBackendUserProvisioned, setBackendUserProvisioned };
}
